var customSelectClassList, customSelectClassListLength, selectElemLength, selectElem, selectedItem, selectItems, newSelectElem;

/* Look for any elements with the class 'language_selection' */
customSelectClassList = document.getElementsByClassName('language_selection');
customSelectClassListLength = customSelectClassList.length;

function closeAllSelects(elem) {
    /* Will close all select boxes in the document,
    except the current select box */
    var y, i, xl, yl, arrNo = [];
    customSelectClassList = document.getElementsByClassName('select-items');
    y = document.getElementsByClassName('select-selected');
    xl = customSelectClassList.length;
    yl = y.length;

    for (i = 0; i < yl; i++) {
        if (elem === y[i]) {
            arrNo.push(i);
        } else {
            y[i].parentElement.classList.remove('active');
        }
    }

    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            customSelectClassList[i].classList.add('select-hide');
        }
    }
}

for (var i = 0; i < customSelectClassListLength; i++) {
    selectElem = customSelectClassList[i].getElementsByTagName('select')[0];
    selectElemLength = selectElem.length;
    /* For each element, create a new div that will act as the selected item */
    selectedItem = document.createElement('div');
    selectedItem.setAttribute('class', 'select-selected');
    selectedItem.innerHTML = selectElem.options[selectElem.selectedIndex].innerHTML;
    customSelectClassList[i].appendChild(selectedItem);

    /*for each element, create a new div that will contain the option list:*/
    selectItems = document.createElement('div');
    selectItems.setAttribute('class', 'select-items select-hide');

    for (var j = 0; j < selectElemLength; j++) {
        /* For each option in the original select element,
        create a new div that will act as an option item */

        /* Create anchor that redirects to another language site */
        var newAnchor = document.createElement('a');
        newAnchor.href = selectElem.options[j].value;

        newSelectElem = document.createElement('div');
        newSelectElem.innerHTML = selectElem.options[j].innerHTML;

        newSelectElem.addEventListener('click', function (e) {

            /*when an item is clicked, update the original select box,
            and the selected item:*/
            var y, i, k, s, h, sLength, yLength;
            s = this.parentNode.parentNode.getElementsByTagName('select')[0];
            sLength = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sLength; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName('same-as-selected');
                    yLength = y.length;
                    for (k = 0; k < yLength; k++) {
                        y[k].removeAttribute('class');
                    }
                    this.setAttribute('class', 'same-as-selected');
                    break;
                }
            }
            h.click();
        });
        newAnchor.appendChild(newSelectElem);
        selectItems.appendChild(newAnchor);
    }

    customSelectClassList[i].appendChild(selectItems);

    customSelectClassList[i].addEventListener('click', function (e) {
        /* When the select box is clicked, close any other select boxes,
        and open/close the current select box */
        e.stopPropagation();

        var thisSelectedItem = document.getElementsByClassName('select-selected')[0];

        closeAllSelects(thisSelectedItem);
        thisSelectedItem.nextSibling.classList.toggle('select-hide');
        this.classList.toggle('active');
    });
}


/* If the user clicks anywhere outside the select box,
then close all select boxes */
document.addEventListener('click', closeAllSelects);

jQuery(function($) {
    /* --------------------- mega-menu ---------------------------------------- */

    // click open/close megamenu
  $('.desktop-menu .mega-ul > li.has-mega-menu.click-to-open').on('click', function (event) {
    event.preventDefault()
    // hide other mega-menus
    $('.desktop-menu .mega-ul > li.has-mega-menu.show-mega-menu').not(this).removeClass('show-mega-menu')
    // show/hide mega-menu
    $(this).toggleClass('show-mega-menu')
  })

  // allow submenu links to work normally
  $('.desktop-menu .mega-ul > li.has-mega-menu.click-to-open .mega-menu__wrapper li').on('click', function (event) {
    event.stopPropagation()

    // ...except header class
    if($(this).hasClass('header')) {
      event.preventDefault()
    }
  })

  // close mega-menu when clicking outside of menu
  $('body').on('click', function(event) {
    const menuContainer = $(event.target).parents('.primary-menu__wrapper.desktop-menu')
    if(menuContainer.length === 0) {
      $('.desktop-menu .mega-ul > li.has-mega-menu.show-mega-menu').removeClass('show-mega-menu')
    }
  })

  // In mobile menu, open/close mega-menu when clicking a link with href="#" at first level
  $('.mobile-menu .mega-ul > li.has-mega-menu > span > a[href^="#"]').on('click', function (event) {
    event.preventDefault()

    $(this).parent('span').siblings('.mega-menu__wrapper').toggleClass('open')
  })

  // In mobile menu, open/close mega-menu when clicking a link with href="#" in submenus
  $('.mobile-menu .mega-ul .subnav li.has-mega-menu a[href^="#"]').on('click', function (event) {
    event.preventDefault()

    $(this).parent().closest('.has-mega-menu').next('.mega-menu-children').toggleClass('children-active')
  })
})